import React, { Component } from "react";
import PropTypes from "prop-types";

class StaticPageTitle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      className: "",
    };
  }
  componentDidMount() {
    this.setState({ className: this.props.className });
  }

  render() {
    const { title } = this.props;
    return (
      <div className={`nw-about-banner ${this.state.className}`}>
        <h1 className="nw-about-banner-title"> {title} </h1>
      </div>
    );
  }
}

StaticPageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: StaticPageTitle,
  component: StaticPageTitle,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/StaticPageTitle/index.js